module.exports = __webpack_public_path__ + "img/option-del.1e28a5a7.svg";